"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jwtDecode = require("jwt-decode");

var _jwtNetworkingService = require("./jwtNetworkingService");

var _jwtTokenUtility = require("./jwtTokenUtility");

var _modelsConstants = require("./modelsConstants");
/* eslint-disable no-undef */

/* eslint-disable consistent-return */

/* eslint-disable lines-between-class-members */
// eslint-disable-next-line camelcase


var ssrDataJson = {
  synonyms: [{
    name: 'ALGO_ONE',
    value: ['MCI5', 'MLAK', 'MBD7', 'MKLB', 'MCAI']
  }, {
    name: 'ALGO_TWO',
    value: ['MCX5', 'MCDJ', 'MEAK', 'MDD7', 'MAZ2']
  }, {
    name: 'ALGO_THREE',
    value: ['MEGR', 'MEDJ', 'MFXT', 'MEQZ', 'MDXT']
  }, {
    name: 'ALGO_FOUR',
    value: ['MBXT', 'MEZ2', 'MEXT', 'MEI5', 'MDI5']
  }, {
    name: 'ALGO_FIVE',
    value: ['MED7', 'MCXJ', 'MAXT', 'MEFD', 'MCXT']
  }],
  api_data: [{
    source: 'addons',
    id: 'sdlkd2l3'
  }, {
    source: 'seat',
    id: 'eue3kds'
  }, {
    source: 'checkout',
    id: 'xmncx278'
  }, {
    source: 'search',
    id: 'wiuwejk2'
  }, {
    source: 'available_dates',
    id: 'jksdkjsd2'
  }, {
    source: 'hotel',
    id: 'hotel876'
  }]
};

var SsrService = /*#__PURE__*/function () {
  function SsrService() {
    var _this = this;

    (0, _classCallCheck2.default)(this, SsrService);
    (0, _defineProperty2.default)(this, "channelHash", void 0);
    (0, _defineProperty2.default)(this, "isChannelIdRetrieved", void 0);
    (0, _defineProperty2.default)(this, "ssrDataTkn", void 0);
    (0, _defineProperty2.default)(this, "isSSRDataTknSet", void 0);
    (0, _defineProperty2.default)(this, "isExpiredToken", function (token) {
      var currentTime = new Date().getTime() / 1000;
      var jwtExpiryTime = (0, _jwtDecode.jwtDecode)(token.replace('Bearer ', ''), {
        complete: true
      }).exp;

      if (currentTime >= jwtExpiryTime) {
        localStorage.removeItem('calendarToken');
        return true;
      }

      return false;
    });
    (0, _defineProperty2.default)(this, "getJsonTokenForCalendarLfcCall", function (env) {
      _jwtNetworkingService.lookupSvc.environment = env;
      return _this.retrieveTokensWithoutHashId();
    });
    (0, _defineProperty2.default)(this, "retrieveTokensWithoutHashId", function () {
      return new Promise(function (resolve, reject) {
        //   if (Platform.OS === 'web') {
        var token = localStorage.getItem('calendarToken'); // console.log("here calling lfc token",token);

        if (!token || _this.isExpiredToken(token)) {
          // console.log("expired");
          return _this.getNewJwtToken(resolve, reject);
        } // console.log("not expired");


        return resolve(token);
      });
    });
    (0, _defineProperty2.default)(this, "getNewJwtToken", function (resolve, reject) {
      _this.getSSRDataJson().then(function (isSSRJsonRetrieved) {
        // console.log("here is the final")
        // console.log("received",isSSRJsonRetrieved);
        if (!isSSRJsonRetrieved) {
          resolve(false);
        }

        return _this.retrieveChannelId();
      }).then(function (channelHash) {
        // console.log("here is the final a")
        if (!channelHash) {
          resolve(false);
        }

        return _this.getSSRData(channelHash);
      }).then(function (ssrData) {
        // console.log("here is the final b",ssrData)
        if (!ssrData) {
          resolve(false);
        }

        return _this.processSSRData(ssrData);
      }).then(function (jsonToken) {
        // console.log("here is the final c",jsonToken);
        if (!jsonToken) {
          resolve(false);
        } // console.log(jwt.decode(jsonToken.replace("Bearer ",""), {complete: true}).payload.exp);
        // console.log("jsonToken",jsonToken);


        resolve(jsonToken);
      }).catch(function (error) {
        // console.log("error",error);
        reject(error);
      });
    });
  }

  (0, _createClass2.default)(SsrService, [{
    key: "getSSRDataJson",
    value:
    /**
     * Will get SSR Data Json from Resources
     */
    function getSSRDataJson() {
      var _this2 = this;

      return new Promise(function (resolve) {
        _this2.ssrDataJson = ssrDataJson;
        resolve(ssrDataJson);
      });
    }
    /**
     * Will get the list of channel hash details
     */

  }, {
    key: "retrieveChannelId",
    value: function retrieveChannelId() {
      var _this3 = this;

      var emptyString = null;
      return new Promise(function (resolve, reject) {
        _jwtNetworkingService.lookupSvc.getChannelHashList().then(function (res) {
          if (!res) {
            resolve(emptyString);
          }

          var resArray = res.map(function (channelDetail) {
            return new _modelsConstants.ChannelDetails(channelDetail.CHANNEL, channelDetail.CHANNEL_HASH, channelDetail.CHANNEL_ID, channelDetail.PLATFORM, channelDetail.PRODUCT_ID);
          });
          if (_this3.channelHash) resolve(_this3.channelHash);
          _this3.channelHash = _jwtTokenUtility.SSRDataUtilities.findHash(resArray, _modelsConstants.SHOPPING_PLATFORM);
          _this3.isChannelIdRetrieved = _this3.channelHash.length > 0;

          if (!_this3.isChannelIdRetrieved) {
            resolve(emptyString);
          }

          resolve(_this3.channelHash);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
    /**
     *
     * @param channelHashId
     *
     * Will get the source, ssrlist and ssrgroup to be used for
     * multi-JWT token
     */

  }, {
    key: "getSSRData",
    value: function getSSRData(channelHashId) {
      var _this4 = this;

      if (!channelHashId) {
        return;
      }

      return new Promise(function (resolve, reject) {
        _jwtNetworkingService.lookupSvc.getSSRDataJWT(channelHashId).then(function (res) {
          if (!res) {
            resolve(null);
          }

          _this4.ssrData = res;
          resolve(_this4.ssrData);
        }).catch(function (error) {
          return reject(error);
        });
      }).catch(function () {// console.error(error);
      });
    }
    /**
     *
     * @param ssrData
     *
     * Will call the right functions to
     * decrypt the jwt tokens
     */

  }, {
    key: "processSSRData",
    value: function processSSRData(ssrData) {
      var _this5 = this;

      return new Promise(function (resolve) {
        // console.log("ssrDataTkn a 1",ssrData);
        // console.log("ssrDataTkn a 2",this.ssrDataJson);
        _this5.ssrDataTkn = _jwtTokenUtility.SSRDataUtilities.processSSRData(ssrData, _this5.ssrDataJson); // console.log("ssrDataTkn b",this.ssrDataTkn);

        _this5.isSSRDataTknSet = _jwtTokenUtility.SSRDataUtilities.verifySSRTknGlobals(_this5.ssrDataTkn); // console.log("ssrDataTkn",this.ssrDataTkn);

        resolve(_this5.ssrDataTkn);
      }).catch(function (error) {
        return reject(error);
      });
    }
  }]);
  return SsrService;
}();

exports.default = SsrService;